import { gql, TypedDocumentNode } from "@apollo/client";

export type AmplitudeAffiliationSection = {
  id: string;
  name: string;
  legacyId: string;
};

export type AmplitudeAffiliationUniversity = {
  legacyId: string;
  name: string;
};

export type AmplitudeAffiliationSectionsResponse = {
  sections: AmplitudeAffiliationSection[];
};

export type AmplitudeAffiliationUniversitiesResponse = {
  universities: AmplitudeAffiliationUniversity[];
};

export type AmplitudeAffiliationUniversitiesVariables = {
  legacyId?: string;
};

export const AMPLITUDE_AFFILIATION_SECTIONS_QUERY: TypedDocumentNode<
  AmplitudeAffiliationSectionsResponse,
  Record<string, never>
> = gql`
  query AmplitudeAffiliationSections {
    sections {
      id
      name
      legacyId
    }
  }
`;

export const AMPLITUDE_AFFILIATION_UNIVERSITIES_QUERY: TypedDocumentNode<
  AmplitudeAffiliationUniversitiesResponse,
  AmplitudeAffiliationUniversitiesVariables
> = gql`
  query AmplitudeAffiliationUniversities($legacyId: String) {
    universities(legacyId: $legacyId) {
      legacyId
      name
    }
  }
`;
